import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import './assets/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/main.css';
import './assets/css/responsive.css';
import './assets/css/animate.css';
import './assets/css/main.css';
import './assets/css/nivo-lightbox.css';
import './assets/css/owl.carousel.min.css';
import './assets/css/owl.theme.css';
import './assets/fonts/line-icons.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
